import styled from "styled-components";

export const TablesContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-start; /* or center if you want them centered */
  flex-wrap: nowrap; /* keep them strictly side by side */
`;

export const StyledTableWrapper = styled.div`
  flex: 0 0 400px; /* each table takes 400px width */
  padding: 1px;
  background-color: #f0f4ff;
  overflow-x: auto;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate; /* needed for spacing */
  border-spacing: 0 12px; /* gap between rows */
  font-size: 12px;
  background-color: transparent;
`;

export const StyledTh = styled.th`
  padding: 4px 16px;
  text-align: left;
  background-color: #ebecee;
  font-weight: 600;
  white-space: nowrap;
`;

export const StyledTd = styled.td`
  padding: 4px 16px;
  background-color: #fff;
  white-space: nowrap;
`;

export const StyledTr = styled.tr`
  &:hover td {
    background-color: #f9f9f9;
  }

  /* rounded row “card” look */
  td:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  td:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;
